import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './core/auth-guard.service';
import { loginRoutes } from './login/login.routing';

const mainRoutes: Routes = [{ path: '', loadChildren: () => import('app/main/main.module').then(m => m.MainModule), canLoad: [AuthGuard] }];

export const routes: Routes = [
    {
        path: 'videos/:directory/:filename',
        data: {
            title: 'ROUTE_TITLES.LeagueDashboard',
        },
        loadChildren: () => import('app/main/main.module').then(m => m.MainModule),
        canLoad: [AuthGuard],
    },
    {
        path: 'player',
        loadChildren: () =>
            import('@sportlogiq/main/player-page/player.module').then(m => m.PlayerPageModule),
        canLoad: [AuthGuard],
    },
    // Whenever accessing a url from the Zendesk Help Center directly (ie: https://sportlogiqhelp.zendesk.com/[...]),
    // if the user isn't logged in Zendesk they will be redirected back to iCE.
    // This path will then be triggered which will load the ZendeskModule, get the jwt token provided by backend and
    // then redirect again back to Zendesk with the session authenticated
    { path: 'zendesk', loadChildren: () => import('app/main/zendesk/zendesk.module').then(m => m.ZendeskModule) },
    ...loginRoutes,
    ...mainRoutes,
    // otherwise redirect to home
    { path: '**', redirectTo: '', pathMatch: 'full' },
];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const appRoutingProviders: any[] = [];

export const routing: ModuleWithProviders<RouterModule> = RouterModule.forRoot(
    routes,
    {
        enableTracing: false,
        paramsInheritanceStrategy: 'emptyOnly',
    }
);
